export default __webpack_public_path__ + "static/media/The Frostflight.a74cbc3c.jpg";